export default __webpack_public_path__ + "static/media/logoby.9bc073b1.jpeg";